/*eslint-env browser*/

import urlParams from "./url_params.js"

function goToChallenge ({url, token, returnUrl}) {
    goToUrl(urlParams.extendUrlWithParams(url, {token, returnUrl}))
}


function goBack ({url, result, token}) {
    if (!token) {
        goToUrl(url)
        return
    }

    let form = document.createElement("form")
    form.setAttribute("method", "post")
    form.setAttribute("action", url)

    if (redirectOnParent) {
        form.setAttribute("target", "_top")
    }

    //form.setAttribute('target', 'view')

    appendHiddenField(form, "token",  token)
    appendHiddenField(form, "result", result)
    document.body.appendChild(form)

    //window.open('', 'view')

    form.submit()
}



function appendHiddenField (form, name, value) {
    let hiddenField = document.createElement("input")
    hiddenField.setAttribute("type", "hidden")
    hiddenField.setAttribute("name",  name)
    hiddenField.setAttribute("value", value)
    form.appendChild(hiddenField)
}


function checkRemoteMode () {
    let {returnUrl, token, status} = urlParams()
    if (!token && !returnUrl) {
        return false
    }

    if (!returnUrl) {
        return {
            error: "no return url has been provided"
        }
    }

    return {
        token,
        returnUrl,
        status,
        goBack: function (result) {
            goBack({
                url: returnUrl,
                result,
                token
            })
        }
    }
}


//for iframes
let redirectOnParent = false


function goToUrl (url) {
    if (redirectOnParent && window.parent) {
        window.parent.location = url
    } else {
        window.location = url
    }
}

function setRedirectOnParent (value) {
    redirectOnParent = value
}


export default {
    goToChallenge,
    checkRemoteMode,
    setRedirectOnParent
}
